tinymce.addI18n("sv_SE", {
  "#": "#",
  Accessibility: "Tillg\xe4nglighet",
  Accordion: "",
  "Accordion body...": "",
  "Accordion summary...": "",
  Action: "\xc5tg\xe4rd",
  Activity: "Aktivitet",
  Address: "Adress",
  Advanced: "Avancerat",
  Align: "Justera",
  "Align center": "Centrera",
  "Align left": "V\xe4nsterjustera",
  "Align right": "H\xf6gerjustera",
  Alignment: "Justering",
  "Alignment {0}": "",
  All: "Alla",
  "Alternative description": "Alternativ beskrivning",
  "Alternative source": "Alternativ k\xe4lla",
  "Alternative source URL": "Alternativ k\xe4llwebbadress",
  Anchor: "Ankare",
  "Anchor...": "Ankare...",
  Anchors: "Ankare",
  "Animals and Nature": "Djur och natur",
  Arrows: "Pilar",
  B: "B",
  "Background color": "Bakgrundsf\xe4rg",
  "Background color {0}": "",
  Black: "Svart",
  Block: "Block",
  "Block {0}": "{0}",
  Blockquote: "Citat",
  Blocks: "Block",
  Blue: "Bl\xe5",
  "Blue component": "Bl\xe5 komponent",
  Body: "Br\xf6dtext",
  Bold: "Fet",
  Border: "Kantlinje",
  "Border color": "Kantlinjef\xe4rg",
  "Border style": "Kantlinjestil",
  "Border width": "Kantlinjebredd",
  Bottom: "Nederkant",
  "Browse files": "",
  "Browse for an image": "Bl\xe4ddra efter en bild",
  "Browse links": "",
  "Bullet list": "Punktlista",
  Cancel: "Avbryt",
  Caption: "Rubrik",
  Cell: "Cell",
  "Cell padding": "Cellutfyllnad",
  "Cell properties": "Cellegenskaper",
  "Cell spacing": "Cellmellanrum",
  "Cell styles": "Cell stil",
  "Cell type": "Celltyp",
  Center: "Centrera",
  Characters: "Tecken",
  "Characters (no spaces)": "Tecken (inga mellanrum)",
  Circle: "Cirkel",
  Class: "Klass",
  "Clear formatting": "Rensa formatering",
  Close: "St\xe4ng",
  Code: "Kod",
  "Code sample...": "Kodexempel...",
  "Code view": "Kodvy",
  "Color Picker": "F\xe4rgv\xe4ljare",
  "Color swatch": "F\xe4rgpalett",
  Cols: "Kolumner",
  Column: "Kolumn",
  "Column clipboard actions": "\xc5tg\xe4rder f\xf6r kolumnurklipp",
  "Column group": "Kolumngrupp",
  "Column header": "Kolumnrubrik",
  "Constrain proportions": "Bibeh\xe5ll proportioner",
  Copy: "Kopiera",
  "Copy column": "Kopiera kolumn",
  "Copy row": "Kopiera rad",
  "Could not find the specified string.":
    "Kunde inte hitta den angivna str\xe4ngen.",
  "Could not load emojis": "Kunde inte ladda emojis",
  Count: "Antal",
  Currency: "Valuta",
  "Current window": "Nuvarande f\xf6nster",
  "Custom color": "Anpassad f\xe4rg",
  "Custom...": "Anpassad...",
  Cut: "Klipp ut",
  "Cut column": "Klipp kolumn",
  "Cut row": "Klipp ut rad",
  "Dark Blue": "M\xf6rkbl\xe5",
  "Dark Gray": "M\xf6rkgr\xe5",
  "Dark Green": "M\xf6rkgr\xf6n",
  "Dark Orange": "M\xf6rkorange",
  "Dark Purple": "M\xf6rklila",
  "Dark Red": "M\xf6rkr\xf6d",
  "Dark Turquoise": "M\xf6rkturkos",
  "Dark Yellow": "M\xf6rkgul",
  Dashed: "Streckad",
  "Date/time": "Datum/tid",
  "Decrease indent": "Minska indrag",
  Default: "Standard",
  "Delete accordion": "",
  "Delete column": "Radera kolumn",
  "Delete row": "Radera rad",
  "Delete table": "Radera tabell",
  Dimensions: "M\xe5tt",
  Disc: "Disk",
  Div: "Div",
  Document: "Dokument",
  Dotted: "Prickad",
  Double: "Dubbel",
  "Drop an image here": "Sl\xe4pp en bild h\xe4r",
  "Dropped file type is not supported": "Filtypen st\xf6ds inte",
  Edit: "Redigera",
  Embed: "B\xe4dda in",
  Emojis: "Emojis",
  "Emojis...": "Emojis...",
  Error: "Fel",
  "Error: Form submit field collision.":
    "Fel: Kollision f\xe4lt f\xf6r s\xe4ndning av formul\xe4r.",
  "Error: No form element found.": "Fel: Inget formul\xe4relement hittades.",
  "Extended Latin": "Ut\xf6kad latin",
  "Failed to initialize plugin: {0}":
    "Kunde inte initiera insticksprogram: {0}",
  "Failed to load plugin url: {0}":
    "Kunde inte l\xe4sa in webbadress f\xf6r insticksprogram: {0}",
  "Failed to load plugin: {0} from url {1}":
    "Kunde inte l\xe4sa in insticksprogram: {0} fr\xe5n webbadress {1}",
  "Failed to upload image: {0}": "Kunde inte ladda upp bild: {0}",
  File: "Arkiv",
  Find: "S\xf6k",
  "Find (if searchreplace plugin activated)":
    "S\xf6k (om searchreplace-insticksprogram \xe4r aktiverat)",
  "Find and Replace": "S\xf6k och ers\xe4tt",
  "Find and replace...": "S\xf6k och ers\xe4tt...",
  "Find in selection": "S\xf6k i markering",
  "Find whole words only": "Hitta endast hela ord",
  Flags: "Flaggor",
  "Focus to contextual toolbar": "Fokusera p\xe5 snabbverktygsrad",
  "Focus to element path": "Fokusera p\xe5 elements\xf6kv\xe4g",
  "Focus to menubar": "Fokusera p\xe5 menyrad",
  "Focus to toolbar": "Fokusera p\xe5 verktygsrad",
  Font: "Teckensnitt",
  "Font size {0}": "",
  "Font sizes": "Textstorlek",
  "Font {0}": "",
  Fonts: "Typsnitt",
  "Food and Drink": "Mat och dryck",
  Footer: "Sidfot",
  Format: "Format",
  "Format {0}": "",
  Formats: "Format",
  Fullscreen: "Helsk\xe4rm",
  G: "G",
  General: "Allm\xe4nt",
  Gray: "Gr\xe5",
  Green: "Gr\xf6n",
  "Green component": "Gr\xf6n komponent",
  Groove: "Urholkad",
  "Handy Shortcuts": "Kortkommandon",
  Header: "Rubrik",
  "Header cell": "Rubrikcell",
  "Heading 1": "Rubrik 1",
  "Heading 2": "Rubrik 2",
  "Heading 3": "Rubrik 3",
  "Heading 4": "Rubrik 4",
  "Heading 5": "Rubrik 5",
  "Heading 6": "Rubrik 6",
  Headings: "Rubriker",
  Height: "H\xf6jd",
  Help: "Hj\xe4lp",
  "Hex color code": "Hexadecimal f\xe4rgkod",
  Hidden: "Dold",
  "Horizontal align": "Horisontell justering",
  "Horizontal line": "Horisontell linje",
  "Horizontal space": "V\xe5gr\xe4t yta",
  ID: "ID",
  "ID should start with a letter, followed only by letters, numbers, dashes, dots, colons or underscores.":
    "ID b\xf6r starta med en bokstav f\xf6ljt av endast bokst\xe4ver, siffror, bindestreck, punkter, tabbar eller understreck.",
  "Image is decorative": "Bilden \xe4r dekorativ",
  "Image list": "Bildlista",
  "Image title": "Bildtitel",
  "Image...": "Bild...",
  "ImageProxy HTTP error: Could not find Image Proxy":
    "ImageProxy HTTP error: Kunde inte hitta bildproxy",
  "ImageProxy HTTP error: Incorrect Image Proxy URL":
    "ImageProxy HTTP error: Felaktig bildproxy URL",
  "ImageProxy HTTP error: Rejected request":
    "ImageProxy HTTP error: Avvisad beg\xe4ran",
  "ImageProxy HTTP error: Unknown ImageProxy error":
    "ImageProxy HTTP error: Ok\xe4nt Bildproxy fel",
  "Increase indent": "\xd6ka indrag",
  Inline: "Inline",
  Insert: "Infoga",
  "Insert Template": "Infoga mall",
  "Insert accordion": "",
  "Insert column after": "Infoga kolumn efter",
  "Insert column before": "Infoga kolumn f\xf6re",
  "Insert date/time": "Infoga datum/tid",
  "Insert image": "Infoga bild",
  "Insert link (if link plugin activated)":
    "Infoga l\xe4nk (om link-insticksprogram \xe4r aktiverat)",
  "Insert row after": "Infoga rad efter",
  "Insert row before": "Infoga rad f\xf6re",
  "Insert table": "Infoga tabell",
  "Insert template...": "Infoga mall...",
  "Insert video": "Infoga video",
  "Insert/Edit code sample": "Infoga/redigera kodexempel",
  "Insert/edit image": "Infoga/redigera bild",
  "Insert/edit link": "Infoga/redigera l\xe4nk",
  "Insert/edit media": "Infoga/redigera media",
  "Insert/edit video": "Infoga/redigera video",
  Inset: "Indrag",
  "Invalid hex color code: {0}": "Ogiltig f\xe4rgkod: {0}",
  "Invalid input": "Ogiltig inmatning",
  Italic: "Kursiv",
  Justify: "Verifiera",
  "Keyboard Navigation": "Tangentbordsnavigering",
  Language: "Spr\xe5k",
  "Learn more...": "L\xe4s mer...",
  Left: "V\xe4nster",
  "Left to right": "V\xe4nster till h\xf6ger",
  "Light Blue": "Ljusbl\xe5",
  "Light Gray": "Ljusgr\xe5",
  "Light Green": "Ljusgr\xf6n",
  "Light Purple": "Ljuslila",
  "Light Red": "Ljusr\xf6d",
  "Light Yellow": "Ljusgul",
  "Line height": "Radavst\xe5nd",
  "Link list": "L\xe4nklista",
  "Link...": "L\xe4nk...",
  "List Properties": "Listegenskaper",
  "List properties...": "Listegenskaper...",
  "Loading emojis...": "Laddar emojis...",
  "Loading...": "Laddar...",
  "Lower Alpha": "Sm\xe5 bokst\xe4ver",
  "Lower Greek": "Sm\xe5 grekiska",
  "Lower Roman": "Sm\xe5 romerska",
  "Match case": "Matcha gemener/VERSALER",
  Mathematical: "Matematiskt",
  "Media poster (Image URL)": "Mediaposter (bildwebbadress)",
  "Media...": "Media...",
  "Medium Blue": "Mellanbl\xe5",
  "Medium Gray": "Mellangr\xe5",
  "Medium Purple": "Mellanlila",
  "Merge cells": "Sammanfoga celler",
  Middle: "Mitten",
  "Midnight Blue": "Midnattsbl\xe5",
  "More...": "Mer...",
  Name: "Namn",
  "Navy Blue": "M\xf6rkbl\xe5",
  "New document": "Nytt dokument",
  "New window": "Nytt f\xf6nster",
  Next: "N\xe4sta",
  No: "Nej",
  "No alignment": "Ingen justering",
  "No color": "Ingen f\xe4rg",
  "Nonbreaking space": "H\xe5rt mellanslag",
  None: "Ingen",
  "Numbered list": "Nummerlista",
  OR: "ELLER",
  Objects: "F\xf6rem\xe5l",
  Ok: "Ok",
  "Open help dialog": "\xd6ppna hj\xe4lpdialogrutan",
  "Open link": "\xd6ppna l\xe4nk",
  "Open link in...": "\xd6ppna l\xe4nk i...",
  "Open popup menu for split buttons":
    "\xd6ppna popup-meny f\xf6r delade knappar",
  Orange: "Orange",
  Outset: "Utst\xe4lld",
  "Page break": "Sidbrytning",
  Paragraph: "Paragraf",
  Paste: "Klistra in",
  "Paste as text": "Klistra in som text",
  "Paste column after": "Klistra in kolumn efter",
  "Paste column before": "Klistra in kolumn f\xf6re",
  "Paste is now in plain text mode. Contents will now be pasted as plain text until you toggle this option off.":
    "Klistra in som oformaterad text. Inneh\xe5llet klistras in som oformaterad text tills du st\xe4nger av det h\xe4r alternativet.",
  "Paste or type a link": "Klistra in eller skriv en l\xe4nk",
  "Paste row after": "Klistra in rad efter",
  "Paste row before": "Klistra in rad f\xf6re",
  "Paste your embed code below:": "Klistra in din inb\xe4ddningskod nedan:",
  People: "M\xe4nniskor",
  Plugins: "Plugins",
  "Plugins installed ({0}):": "Installerade insticksprogram ({0}):",
  "Powered by {0}": "St\xf6ds av {0}",
  Pre: "Pre",
  Preferences: "Inst\xe4llningar",
  Preformatted: "F\xf6rformaterad",
  "Premium plugins:": "Premium-insticksprogram",
  "Press the Up and Down arrow keys to resize the editor.": "",
  "Press the arrow keys to resize the editor.": "",
  "Press {0} for help": "",
  Preview: "F\xf6rhandsgranska",
  Previous: "F\xf6reg\xe5ende",
  Print: "Skriv ut",
  "Print...": "Skriv ut...",
  Purple: "Lila",
  Quotations: "Citattecken",
  R: "R",
  "Range 0 to 255": "Spann 0 till 255",
  Red: "R\xf6d",
  "Red component": "R\xf6d komponent",
  Redo: "G\xf6r om",
  Remove: "Ta bort",
  "Remove color": "Ta bort f\xe4rg",
  "Remove link": "Ta bort l\xe4nk",
  Replace: "Ers\xe4tt",
  "Replace all": "Ers\xe4tt alla",
  "Replace with": "Ers\xe4tt med",
  Resize: "\xc4ndra storlek",
  "Restore last draft": "\xc5terst\xe4ll senaste utkast",
  "Reveal or hide additional toolbar items": "",
  "Rich Text Area": "Rich Text Omr\xe5de",
  "Rich Text Area. Press ALT-0 for help.":
    "Omr\xe5de med formaterad text. Tryck p\xe5 ALT-0 f\xf6r hj\xe4lp.",
  "Rich Text Area. Press ALT-F9 for menu. Press ALT-F10 for toolbar. Press ALT-0 for help":
    "Omr\xe5de med formaterad text. Tryck p\xe5 ALT-F9 f\xf6r att \xf6ppna menyn. Tryck p\xe5 ALT-F10 f\xf6r att \xf6ppna verktygsraden. Tryck p\xe5 ALT-0 f\xf6r hj\xe4lp.",
  Ridge: "Rygg",
  Right: "H\xf6ger",
  "Right to left": "H\xf6ger till v\xe4nster",
  Row: "Rad",
  "Row clipboard actions": "\xc5tg\xe4rder f\xf6r radurklipp",
  "Row group": "Radgrupp",
  "Row header": "Radrubrik",
  "Row properties": "Radegenskaper",
  "Row type": "Radtyp",
  Rows: "Rader",
  Save: "Spara",
  "Save (if save plugin activated)":
    "Spara (om save-insticksprogram \xe4r aktiverat)",
  Scope: "Omr\xe5de",
  Search: "S\xf6k",
  "Select all": "Markera allt",
  "Select...": "V\xe4lj...",
  Selection: "Val",
  Shortcut: "Genv\xe4g",
  "Show blocks": "Visa block",
  "Show caption": "Visa bildtext",
  "Show invisible characters": "Visa osynliga tecken",
  Size: "Storlek",
  Solid: "Solid",
  Source: "K\xe4lla",
  "Source code": "K\xe4llkod",
  "Special Character": "Specialtecken",
  "Special character...": "Specialtecken...",
  "Split cell": "Dela cell",
  Square: "Fyrkant",
  "Start list at number": "Starta listan p\xe5 nummer",
  Strikethrough: "Genomstruken",
  Style: "Stil",
  Subscript: "Neds\xe4nkt",
  Superscript: "Upph\xf6jd",
  "Switch to or from fullscreen mode":
    "V\xe4xla till eller fr\xe5n fullsk\xe4rmsl\xe4ge",
  Symbols: "Symboler",
  "System Font": "Systemtypsnitt",
  Table: "Tabell",
  "Table caption": "Tabelltext",
  "Table properties": "Tabellegenskaper",
  "Table styles": "Tabell stil",
  Template: "Mall",
  Templates: "Mallar",
  Text: "Text",
  "Text color": "Textf\xe4rg",
  "Text color {0}": "",
  "Text to display": "Text att visa",
  "The URL you entered seems to be an email address. Do you want to add the required mailto: prefix?":
    "Webbadressen du angav verkar vara en e-postadress. Vill du l\xe4gga till det obligatoriska prefixet mailto:?",
  "The URL you entered seems to be an external link. Do you want to add the required http:// prefix?":
    "Webbadressen du angav verkar vara en extern l\xe4nk. Vill du l\xe4gga till det obligatoriska prefixet http://?",
  "The URL you entered seems to be an external link. Do you want to add the required https:// prefix?":
    "URL:en du angav verkar vara en extern-l\xe4nk. Vill du l\xe4gga till det obligatoriska https:// prefixet?",
  Title: "Titel",
  "To open the popup, press Shift+Enter":
    "Tryck p\xe5 Shift\xa0+\xa0Enter f\xf6r att \xf6ppna popup-f\xf6nstret",
  "Toggle accordion": "",
  Tools: "Verktyg",
  Top: "\xd6verkant",
  "Travel and Places": "Resa och platser",
  Turquoise: "Turkos",
  Underline: "Understruken",
  Undo: "\xc5ngra",
  Upload: "Ladda upp",
  "Uploading image": "Laddar upp bild",
  "Upper Alpha": "Stora bokst\xe4ver",
  "Upper Roman": "Stora romerska",
  Url: "Webbadress",
  "User Defined": "Anv\xe4ndardefinierade",
  Valid: "Giltig",
  Version: "Version",
  "Vertical align": "Vertikal justering",
  "Vertical space": "Lodr\xe4t yta",
  View: "Visa",
  "Visual aids": "Visuella hj\xe4lpmedel",
  Warn: "Varning",
  White: "Vit",
  Width: "Bredd",
  "Word count": "Ordantal",
  Words: "Ord",
  "Words: {0}": "Ord: {0}",
  Yellow: "Gul",
  Yes: "Ja",
  "You are using {0}": "Du anv\xe4nder {0}",
  "You have unsaved changes are you sure you want to navigate away?":
    "Det finns osparade \xe4ndringar. \xc4r du s\xe4ker p\xe5 att du vill navigera vidare?",
  "Your browser doesn't support direct access to the clipboard. Please use the Ctrl+X/C/V keyboard shortcuts instead.":
    "Din webbl\xe4sare st\xf6djer inte direkt \xe5tkomst till klippboken. Anv\xe4nd kortkommandona Ctrl\xa0+\xa0X/C/V i st\xe4llet.",
  alignment: "justering",
  "austral sign": "australtecken",
  "cedi sign": "ceditecken",
  "colon sign": "kolon",
  "cruzeiro sign": "cruzeirotecken",
  "currency sign": "valutatecken",
  "dollar sign": "dollartecken",
  "dong sign": "dongtecken",
  "drachma sign": "drachmertecken",
  "euro-currency sign": "eurotecken",
  example: "exempel",
  formatting: "formatering",
  "french franc sign": "franctecken",
  "german penny symbol": "tecken f\xf6r tysk penny",
  "guarani sign": "guaranitecken",
  history: "historik",
  "hryvnia sign": "hryvniatecken",
  indentation: "indragning",
  "indian rupee sign": "tecken f\xf6r indisk rupee",
  "kip sign": "kiptecken",
  "lira sign": "liratecken",
  "livre tournois sign": "tecken f\xf6r livre tournois",
  "manat sign": "manattecken",
  "mill sign": "milltecken",
  "naira sign": "nairatecken",
  "new sheqel sign": "schekeltecken",
  "nordic mark sign": "tecken f\xf6r nordisk mark",
  "peseta sign": "pesetastecken",
  "peso sign": "pesotecken",
  "ruble sign": "rubeltecken",
  "rupee sign": "rupeetecken",
  "spesmilo sign": "spesmilotecken",
  styles: "stilar",
  "tenge sign": "tengetecken",
  "tugrik sign": "tugriktecken",
  "turkish lira sign": "tecken f\xf6r turkisk lira",
  "won sign": "wontecken",
  "yen character": "yentecken",
  "yen/yuan character variant one": "yen-/yuantecken variant ett",
  "yuan character": "yuantecken",
  "yuan character, in hong kong and taiwan": "yuantecken i Hongkong och Taiwan",
  "{0} characters": "{0} tecken",
  "{0} columns, {1} rows": "",
  "{0} words": "{0} ord",
});
